<div class="fechar">

    <h2>Orçamento Cancelado com sucesso!</h2>
    <button (click)="close()">
        <span>Fechar</span>
    </button>
</div>